export const Stepper = ({ step }: { step: number }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        position: 'relative',
        zIndex: -1,
      }}
    >
      <span
        style={{
          fontSize: 12,
          fontWeight: 'bold',
          textTransform: 'uppercase',
          color: '#2E3E56',
        }}
      >
        Step
      </span>
      <div
        style={{
          position: 'absolute',
          color: '#92CAF5',
          fontSize: 150,
          fontWeight: 800,
          padding: '0 16px',
        }}
      >
        {step}
      </div>
    </div>
  );
}